import React, { useState } from "react"; 
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import BasePopup from "../../../Components/Base/BasePopup";
import DatePickerComponent from "../../../Components/Forms/DatePickerComponent";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import axios from "axios";
import { Helper } from "../../../Services/Helpers/Helper";

const RelatorioReportTrackingPopup = (props: any) => {
    const [relatorio, setRelatorio] = useState<any>({});
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();

    const tipoSaidas = [
        {'id': 'html', 'descricao': 'HTML'},
        {'id': 'planilha', 'descricao': 'Planilha'}
    ];
   
    async function gerarAsync() {
        console.log(relatorio);
        if (relatorio.data_inicial == null || relatorio.data_final == null) {
            enqueueSnackbar('Informe um intervalo válido.', {variant: 'warning'});
            return;
        }

        if (relatorio.data_inicial > relatorio.data_final) {
            enqueueSnackbar('Informe um intervalo válido.', {variant: 'warning'});
            return;
        }

        var diferenca = Math.abs(relatorio.data_inicial - relatorio.data_final);

        var dia = 1000 * 60 * 60 * 24;
        var dias = Math.round(diferenca / dia);
        if (dias >= 31) {
            enqueueSnackbar('Período inválido! O intervalo informado deve ser menor que 31 dias.', {variant: 'warning'});
            return;
        }

        Helper.WindowsPostOpen(`${axios.defaults.baseURL}relatorioReportTracking`, relatorio);
    }

    return (
        <BasePopup
            height="470px"
            size={'md'}
            buttonTitle="Gerar"
            title="Report Tracking"
            isOpen={props.isOpen}
            onClose={props.onClose}
            onClickFirstButtonPopupCallback={gerarAsync}
            isPesquisa='false'
            confirmClose={false}>
            <span className="row">
                <DatePickerComponent
                    label="Data Inicial"
                    required
                    divClassName="col-lg-6 col-md-6 col-sm-6 col-6"
                    className="col-md-12"
                    model={relatorio}
                    field="data_inicial" />

                <DatePickerComponent
                    label="Data Final"
                    required
                    divClassName="col-lg-6 col-md-6 col-sm-6 col-6"
                    className="col-md-12"
                    model={relatorio}
                    field="data_final" />

                <InlineSearchComponent
                    label='Operação'
                    urlApi='buscaOperacoes'
                    valueField='id'
                    textField='nome_completo'
                    model={relatorio}
                    modelField="operacao_id" />

                <TextFieldComponent 
                    label="Placa"
                    divClassName="col-lg-6 col-md-6 col-sm-6 col-6"
                    model={relatorio}
                    field="placa" />

                <TextFieldComponent
                    label="Frota"
                    divClassName="col-lg-6 col-md-6 col-sm-6 col-6"
                    model={relatorio}
                    field="frota" />

                <DropDownListComponent 
                    divClassName="col-lg-6 col-md-6 col-sm-6 col-6"
                    label='Saída'
                    required
                    options={tipoSaidas}
                    model={relatorio}
                    modelField="saida"
                    valueField='id'
                    textField='descricao' />
            </span>
        </BasePopup>
    );
}

export default RelatorioReportTrackingPopup;

